//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMerchantOverview } from '@/api/alliance';
export default {
  name: 'AllianceMerchantOverview',
  data: function data() {
    return {
      loading: false,
      overview: {},
      cards: [{
        key: 'count',
        label: '核销笔数',
        desc: '已核销 + 部分退款',
        points: true
      }, {
        key: 'deductPoints',
        label: '抵扣积分',
        desc: '用户实际扣掉的积分',
        points: true
      }, {
        key: 'deductAmount',
        label: '抵扣金额',
        desc: '积分折算成的金额'
      }, {
        key: 'receivable',
        label: '商户应收',
        desc: '已扣平台服务费'
      }],
      accountCards: [{
        key: 'pendingCheck',
        label: '待核对',
        desc: '核销后进入，等待平台核对'
      }, {
        key: 'pendingSettle',
        label: '待结算',
        desc: '核对完成，观察期内'
      }, {
        key: 'withdrawable',
        label: '可提现',
        desc: '观察期已过'
      }]
    };
  },
  computed: {
    today: function today() {
      return this.overview.today || {};
    },
    month: function month() {
      return this.overview.month || {};
    },
    account: function account() {
      return this.overview.account || {};
    }
  },
  created: function created() {
    this.load();
  },
  methods: {
    // 后端一律用分存金额，不用浮点。这里只是展示
    yuan: function yuan(fen) {
      return '￥' + (Number(fen || 0) / 100).toFixed(2);
    },
    num: function num(value) {
      return Number(value || 0);
    },
    load: function load() {
      var _this = this;
      this.loading = true;
      getMerchantOverview().then(function (res) {
        _this.overview = res || {};
      }).finally(function () {
        _this.loading = false;
      });
    },
    goVerify: function goVerify() {
      this.$router.push('/alliance/verify');
    }
  }
};